import { Arrays, Calculation, CostAccountingDimensionScope, UserDefinedRow } from "@salaxy/core";

import { SessionService } from "../../services";
import { CostAccountingController } from "./CostAccountingController";

/**
 * Handles the user interaction for entering cost accounting data for the calculation row.
 */
export class CalcRowCostAccountingController extends CostAccountingController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["SessionService"];

  /** The calculation for row */
  public calc: Calculation;

  /** Current row */
  public row: UserDefinedRow;

  /**
   * Creates a new CalcCostAccountingController
   * @ignore
   */
  constructor(
    sessionService: SessionService,

  ) {
    super(sessionService);
  }

  /**
   * Implement IController
   */
  public $onInit() {
    this.scope = CostAccountingDimensionScope.Row;
    super.$onInit();
  }

  /**
   * Returns true if the current calculation is read only.
   */
   public get isReadOnly(): boolean {
    if (this.readOnly === true || this.readOnly === false) {
      return this.readOnly;
    }
    return this.calc.isReadOnly;
  }

  /** Returns the cost accounting model type */
  public get isLegacy(): boolean {
    //backward compat.
    if (this.calc.usecase?.uri === "/UsecaseDefinition/FI53POYS0025543933/costcenter-percentages") {
      return true;
    }
    return false;
  }

  /** Returns total cost center percentage */
  public getLegacySum(): number {
    if (this.isLegacy) {
      return Arrays.sum(this.row?.data?.dimensions?.costCenter ?? [], (x: any) => x.percent ?? 0);
    }
    return 0;
  }

  /** Returns current costCenter. */
  public get costCenter() {
    if (this.isLegacy) {
      if (!this.row.data) {
        this.row.data = {};
      }
      if (!this.row.data.dimensions) {
        this.row.data.dimensions = {};
      }
      if (!this.row.data.dimensions.costCenter) {
        this.row.data.dimensions.costCenter = [];
      }
    }

    return this.row.data?.dimensions?.costCenter;
  }
}
